import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('apuracao_acao', 'listagem');

const apuracaoActions = {
  listarPorCliente: { method: 'GET', url: `${basePath}/por-cliente` },
  listarPorHolding: { method: 'GET', url: `${basePath}/por-holding` },
};

export default resource => resource(`${basePath}`, {}, apuracaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/apuracao-acao-listagem.js